import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AnimeCard from '@/components/base/AnimeCard';
import { animeList, categories } from '@/mocks/anime';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'all');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const filteredAnimes = activeCategory === 'all'
    ? animeList
    : animeList.filter((a) => a.categorySlug === activeCategory);

  const currentCategoryName = categories.find((c) => c.slug === activeCategory)?.name || '全部';

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.fengchedongman.com/' },
      { '@type': 'ListItem', position: 2, name: currentCategoryName, item: `https://www.fengchedongman.com/category/${activeCategory}` },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main className="pt-20">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-6xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">{currentCategoryName}</span>
            </nav>

            <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              {currentCategoryName}动漫
            </h1>
            <p className="text-sm text-foreground-500 mb-8">
              共 {filteredAnimes.length} 部{currentCategoryName === '全部' ? '' : currentCategoryName}动漫作品
            </p>

            <div className="flex flex-wrap items-center gap-2 mb-8 px-1 py-1 bg-background-100 rounded-full">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-primary-500 hover:bg-background-50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredAnimes.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
                {filteredAnimes.map((anime) => (
                  <AnimeCard key={anime.id} anime={anime} size="medium" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-400">该分类暂无动漫作品</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}